<template>
  <v-app-bar
    app
    color="white"
    :height="isMobile() ? '140' : '100'"
    elevation="0"
  >
    <v-container class="pa-0" fluid>
      <v-row class="pa-0 ma-0">
        <v-col v-if="!isMobile()" md="12" cols="12">
          <v-img
            contain
            max-height="100"
            @click="$router.push({ name: 'Home' })"
            src="@/assets/form/encabezado-form.gif"
          ></v-img>
        </v-col>
        <v-col v-if="isMobile()" md="12" cols="12">
          <v-img
            contain
            max-height="75"
            @click="$router.push({ name: 'Home' })"
            src="@/assets/form/iap-uam-mobile.gif"
          ></v-img>
          <v-img
            contain
            max-height="60"
            @click="$router.push({ name: 'Home' })"
            src="@/assets/form/iap-uam-mobile2.gif"
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return { tab: null };
  },
  methods: {
    changeTab(tab, route) {
      console.log(tab, route);
      this.tab = tab;
      this.$router.push({ name: route });
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
/* Helper classes */
.basil {
  background-color: #fffbe6 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>